import angular from 'angular';
import uiRouter from 'angular-ui-router';
import dashboardComponent from './dashboard.component';
import RecentContacts from './recentContacts/recentContacts';
import OpenEnquiries from './openEnquiries/openEnquiries';
import OpenFinances from './openFinances/openFinances';
import PendingDeliveries from './pendingDeliveries/pendingDeliveries';
import ContactMatch from './contactMatch/contactMatch';
import VehicleMatch from './vehicleMatch/vehicleMatch';
import WebEnquiries from './webEnquiries/webEnquiries';
import ExpiringContacts from './expiringContacts/expiringContacts';

let dashboardModule = angular.module('dashboard', [
  uiRouter,
  OpenEnquiries,
  RecentContacts,
  PendingDeliveries,
  ContactMatch,
  VehicleMatch,
  OpenFinances,
  WebEnquiries,
  ExpiringContacts
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider
    .state('dashboard', {
      url: '/dashboard',
      component: 'dashboard',
      params: {
      }
    });
})

.component('dashboard', dashboardComponent)

.name;

export default dashboardModule;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/dashboard.js